/**
 * Übersetzungstabelle für `WikiVehicleCuratedData.pledge_availability` — reiner
 * Freitext aus starcitizen.tools, keine feste Werteliste. Vollständigkeit
 * verifiziert gegen alle in der API vorkommenden Werte (Stand: kompletter
 * Fahrzeug-Index, 2026-09). Unbekannte künftige Werte fallen auf den
 * Originaltext zurück statt auf eine geratene Übersetzung.
 */
const PLEDGE_AVAILABILITY_LABELS: Record<string, string> = {
  'Always available': 'Immer verfügbar',
  'Time Limited': 'Zeitlich begrenzt',
  'Time-limited sales': 'Zeitlich begrenzter Verkauf',
  'Quantity-limited sales': 'Mengenbegrenzter Verkauf',
  'Limited edition': 'Limitierte Edition',
  'Limited edition (No longer available)': 'Limitierte Edition (nicht mehr verfügbar)',
  'Limited (Reward)': 'Limitiert (Belohnung)',
  'Limited: Reward purchase token': 'Limitiert: Belohnungs-Kauftoken',
  'Limited availability*': 'Begrenzt verfügbar*',
  'Not available for sale': 'Nicht käuflich',
  'Out of production': 'Nicht mehr produziert',
  'Promotion-only': 'Nur bei Aktionen',
  '(No longer available)': '(Nicht mehr verfügbar)',
};

export function getPledgeAvailabilityLabel(value: string | null | undefined): string | null {
  if (!value) return null;
  return PLEDGE_AVAILABILITY_LABELS[value] ?? value;
}
